import { ColorProperty } from "./colorproperty";

export class FillColorProperty extends ColorProperty{
    
}